module.exports = __webpack_public_path__ + "static/media/fa-user.f17f0522.png";